import { useState, useEffect } from "react";
import { supabase } from "../supabaseClient";

const GOLD     = "#C9A96E";
const INK      = "#1C1915";
const INK_SOFT = "#4A4540";
const BORDER   = "#E7E1D8";
const SOFT_BG  = "#F7F5F2";
const GREEN    = "#1A7A44";
const FF_PLAYFAIR = "'Playfair Display', Georgia, serif";

function readLs(key, fallback = "") {
  try {
    const v = localStorage.getItem(key);
    return v != null ? v : fallback;
  } catch {
    return fallback;
  }
}

function writeLs(key, value) {
  try {
    if (value === "" || value == null) localStorage.removeItem(key);
    else localStorage.setItem(key, value);
  } catch {
    /* ignore */
  }
}

export default function BrandingSettingsPage({ projectData, setProjectData, cabinetId }) {
  const [local, setLocal]   = useState({ ...projectData });
  const [saved, setSaved]   = useState(false);
  const [error, setError]   = useState("");

  const [yousignApi, setYousignApi]     = useState(() => readLs("yoma_yousign_api_key"));
  const [yousignEnv, setYousignEnv]     = useState(() => readLs("yoma_yousign_env", "test"));
  const [docusignKey, setDocusignKey]   = useState(() => readLs("yoma_docusign_key"));
  const [docusignAcct, setDocusignAcct] = useState(() => readLs("yoma_docusign_account_id"));
  const [stripePk, setStripePk]       = useState(() => readLs("yoma_stripe_pk"));
  const [integTestMsg, setIntegTestMsg] = useState("");

  useEffect(() => {
    const id = "yoma-fonts-branding-integrations";
    if (document.getElementById(id)) return;
    const link = document.createElement("link");
    link.id = id;
    link.rel = "stylesheet";
    link.href =
      "https://fonts.googleapis.com/css2?family=Playfair+Display:wght@500;600;700&display=swap";
    document.head.appendChild(link);
  }, []);

  function handleLogoUpload(e) {
    const file = e.target.files[0];
    if (!file) return;

    // Vérification taille max 2MB
    if (file.size > 2 * 1024 * 1024) {
      setError("Le fichier est trop lourd (max 2 Mo). Compresse l'image avant de l'importer.");
      return;
    }

    setError("");
    const reader = new FileReader();
    reader.onload = (ev) => setLocal(prev => ({ ...prev, companyLogo: ev.target.result }));
    reader.readAsDataURL(file);
  }

  async function handleSave() {
    const updated = { ...projectData, ...local };
    setProjectData(updated);
    if (cabinetId) {
      try {
        await supabase
          .from("cabinets")
          .update({ branding: updated })
          .eq("id", cabinetId);
      } catch (e) {
        console.error("Erreur sauvegarde branding Supabase:", e);
      }
    }
    setSaved(true);
    setTimeout(() => setSaved(false), 2500);
  }

  function handleRemoveLogo() {
    setLocal(prev => ({ ...prev, companyLogo: "" }));
  }

  const labelStyle = {
    display: "block", fontSize: 11,
    letterSpacing: "0.12em", textTransform: "uppercase",
    color: INK_SOFT, marginBottom: 8, fontWeight: 600,
  };

  const inputStyle = {
    width: "100%", padding: "10px 14px",
    border: `1px solid ${BORDER}`, borderRadius: 8,
    fontSize: 14, boxSizing: "border-box",
    color: INK, background: "#fff", outline: "none",
  };

  const cardStyle = {
    background: "#fff", border: `1px solid ${BORDER}`,
    borderRadius: 12, padding: "28px 32px", marginBottom: 20,
  };

  return (
    <div style={{ maxWidth: 640, fontFamily: "system-ui, -apple-system, sans-serif" }}>

      {/* En-tête */}
      <div style={{ marginBottom: 28 }}><div style={{ fontSize: 11, letterSpacing: "0.15em", textTransform: "uppercase", color: GOLD, marginBottom: 6 }}>
          Outils — Branding
        </div><div style={{ fontSize: 22, fontWeight: 700, color: INK }}>Identité visuelle</div><div style={{ fontSize: 13, color: INK_SOFT, marginTop: 4 }}>
          Ces informations apparaissent dans la barre supérieure de l'application.
        </div></div>

      {/* Nom société */}
      <div style={cardStyle}><div style={{ display: "flex", alignItems: "center", gap: 10, marginBottom: 20 }}><div style={{ width: 20, height: 1, background: GOLD }} /><span style={{ fontSize: 10, letterSpacing: "0.18em", textTransform: "uppercase", color: GOLD }}>Nom de la société</span><div style={{ flex: 1, height: 1, background: BORDER }} /></div><label style={labelStyle}>Raison sociale</label><input
          style={inputStyle}
          value={local.companyName}
          onChange={e => setLocal(prev => ({ ...prev, companyName: e.target.value }))}
          placeholder="YOMA DESIGN"
        /><p style={{ margin: "6px 0 0", fontSize: 11, color: "#aaa", fontStyle: "italic" }}>
          Affiché à côté du logo dans la barre du haut.
        </p></div>

      {/* Logo */}
      <div style={cardStyle}><div style={{ display: "flex", alignItems: "center", gap: 10, marginBottom: 20 }}><div style={{ width: 20, height: 1, background: GOLD }} /><span style={{ fontSize: 10, letterSpacing: "0.18em", textTransform: "uppercase", color: GOLD }}>Logo</span><div style={{ flex: 1, height: 1, background: BORDER }} /></div>

        {/* Zone upload */}
        <label style={{
          display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center",
          gap: 10, padding: "28px 20px", border: `2px dashed ${BORDER}`,
          borderRadius: 10, cursor: "pointer", background: SOFT_BG,
          transition: "border-color 0.2s",
        }}><input type="file" accept="image/*" onChange={handleLogoUpload} style={{ display: "none" }} /><div style={{ fontSize: 28 }}></div><div style={{ fontSize: 13, color: INK_SOFT, textAlign: "center" }}>
            Clique pour importer un logo<br /><span style={{ fontSize: 11, color: "#aaa" }}>PNG, JPG, SVG — max 2 Mo</span></div></label>

        {error && (
          <div style={{ marginTop: 10, padding: "10px 14px", background: "#FDEDEC", border: "1px solid #F5B7B1", borderRadius: 8, fontSize: 12, color: "#C0392B" }}>
             {error}
          </div>
        )}

        {/* Aperçu */}
        {local.companyLogo && (
          <div style={{ marginTop: 20 }}><label style={labelStyle}>Aperçu</label><div style={{
              padding: 20, background: SOFT_BG, borderRadius: 10,
              display: "inline-flex", alignItems: "center",
              border: `1px solid ${BORDER}`,
            }}><img
                src={local.companyLogo}
                alt="Aperçu logo"
                style={{
                  maxHeight: local.logoSize,
                  maxWidth: local.logoSize * 2,
                  objectFit: "contain",
                }}
              /></div><div style={{ marginTop: 16 }}><label style={labelStyle}>Taille d'affichage — {local.logoSize}px</label><input
                type="range" min={30} max={160} step={5}
                value={local.logoSize}
                onChange={e => setLocal(prev => ({ ...prev, logoSize: parseInt(e.target.value) }))}
                style={{ width: "100%", accentColor: GOLD }}
              /><div style={{ display: "flex", justifyContent: "space-between", fontSize: 11, color: "#aaa", marginTop: 2 }}><span>30px</span><span>160px</span></div></div><button
              onClick={handleRemoveLogo}
              style={{
                marginTop: 16, padding: "8px 18px",
                background: "transparent", border: `1px solid ${BORDER}`,
                borderRadius: 7, fontSize: 12, color: INK_SOFT,
                cursor: "pointer",
              }}
            >
              Supprimer le logo
            </button></div>
        )}
      </div>

      {/* Aperçu top bar */}
      <div style={cardStyle}><div style={{ display: "flex", alignItems: "center", gap: 10, marginBottom: 16 }}><div style={{ width: 20, height: 1, background: GOLD }} /><span style={{ fontSize: 10, letterSpacing: "0.18em", textTransform: "uppercase", color: GOLD }}>Aperçu barre du haut</span><div style={{ flex: 1, height: 1, background: BORDER }} /></div><div style={{
          background: "#fff", border: `1px solid ${BORDER}`, borderRadius: 8,
          padding: "12px 20px", display: "flex", alignItems: "center",
          justifyContent: "space-between",
        }}><div style={{ display: "flex", alignItems: "center", gap: 12 }}>
            {local.companyLogo ? (
              <img
                src={local.companyLogo}
                alt="Logo"
                style={{ maxHeight: local.logoSize, maxWidth: local.logoSize * 2, objectFit: "contain" }}
              />
            ) : null}
            {(!local.companyLogo || local.companyName) && (
              <div style={{ fontWeight: 800, fontSize: 15, color: INK }}>
                {local.companyName || "YOMA DESIGN"}
              </div>
            )}
          </div><div style={{ fontSize: 13, fontWeight: 600, color: INK_SOFT }}>Nom de la page</div></div></div>

      {/* Devise du projet */}
      <div style={cardStyle}><div style={{ display: "flex", alignItems: "center", gap: 10, marginBottom: 20 }}><div style={{ width: 20, height: 1, background: GOLD }} /><span style={{ fontSize: 10, letterSpacing: "0.18em", textTransform: "uppercase", color: GOLD }}>Devise du projet</span><div style={{ flex: 1, height: 1, background: BORDER }} /></div><label style={labelStyle}>Devise principale</label><select
          style={inputStyle}
          value={local.deviseCode ?? "MAD"}
          onChange={e => setLocal(prev => ({ ...prev, deviseCode: e.target.value }))}
        ><option value="MAD">MAD — Dirham marocain</option><option value="EUR">EUR — Euro</option><option value="USD">USD — Dollar US</option></select><p style={{ margin: "6px 0 0", fontSize: 11, color: "#aaa", fontStyle: "italic" }}>
          Utilisée pour les montants dans les devis, contrats et tableaux.
        </p></div>

      {/* Informations société / émetteur (contrats & documents) */}
      <div style={cardStyle}><div style={{ display: "flex", alignItems: "center", gap: 10, marginBottom: 20 }}><div style={{ width: 20, height: 1, background: GOLD }} /><span style={{ fontSize: 10, letterSpacing: "0.18em", textTransform: "uppercase", color: GOLD }}>Informations société / émetteur</span><div style={{ flex: 1, height: 1, background: BORDER }} /></div><p style={{ margin: "0 0 16px", fontSize: 12, color: INK_SOFT }}>
          Utilisées dans les contrats, propositions et PDF (signature, en-têtes).
        </p><label style={labelStyle}>Nom société</label><input
          style={inputStyle}
          value={local.emetteur_nom ?? ""}
          onChange={e => setLocal(prev => ({ ...prev, emetteur_nom: e.target.value }))}
          placeholder="ex. YOMA DESIGN"
        /><label style={{ ...labelStyle, marginTop: 14 }}>Représentant</label><input
          style={inputStyle}
          value={local.emetteur_representant ?? ""}
          onChange={e => setLocal(prev => ({ ...prev, emetteur_representant: e.target.value }))}
          placeholder="ex. Monsieur Youssef KABDANI"
        /><label style={{ ...labelStyle, marginTop: 14 }}>Désignation (court)</label><input
          style={inputStyle}
          value={local.emetteur_designation ?? ""}
          onChange={e => setLocal(prev => ({ ...prev, emetteur_designation: e.target.value }))}
          placeholder="ex. YOMA DESIGN (si vide, le nom société est utilisé)"
        /><label style={{ ...labelStyle, marginTop: 14 }}>Adresse</label><input
          style={inputStyle}
          value={local.emetteur_adresse ?? ""}
          onChange={e => setLocal(prev => ({ ...prev, emetteur_adresse: e.target.value }))}
          placeholder="Adresse postale de la société"
        /><label style={{ ...labelStyle, marginTop: 14 }}>Email</label><input
          style={inputStyle}
          type="email"
          value={local.emetteur_email ?? ""}
          onChange={e => setLocal(prev => ({ ...prev, emetteur_email: e.target.value }))}
          placeholder="contact@exemple.com"
        /><label style={{ ...labelStyle, marginTop: 14 }}>Téléphone</label><input
          style={inputStyle}
          type="tel"
          value={local.emetteur_telephone ?? ""}
          onChange={e => setLocal(prev => ({ ...prev, emetteur_telephone: e.target.value }))}
          placeholder="+212 5 00 00 00 00"
        /><label style={{ ...labelStyle, marginTop: 14 }}>Pays</label><input
          style={inputStyle}
          value={local.emetteur_pays ?? ""}
          onChange={e => setLocal(prev => ({ ...prev, emetteur_pays: e.target.value }))}
          placeholder="ex. Maroc"
        /><label style={{ ...labelStyle, marginTop: 14 }}>Identifiants société (RC, IF, ICE, SIRET…)</label><input
          style={inputStyle}
          value={local.emetteur_identifiants ?? ""}
          onChange={e => setLocal(prev => ({ ...prev, emetteur_identifiants: e.target.value }))}
          placeholder="Optionnel — un par ligne ou séparés par des virgules"
        /></div>

      {/* ——— Intégrations & Signatures ——— */}
      <div style={{ marginTop: 40, marginBottom: 8 }}>
        <div style={{ fontSize: 11, letterSpacing: "0.15em", textTransform: "uppercase", color: GOLD, marginBottom: 6 }}>
          Connectivité
        </div>
        <h2 style={{ fontFamily: FF_PLAYFAIR, fontSize: 22, fontWeight: 600, color: INK, margin: "0 0 8px", lineHeight: 1.25 }}>
          Intégrations &amp; Signatures
        </h2>
        <p style={{ fontSize: 13, color: INK_SOFT, margin: 0, maxWidth: 520 }}>
          Connectez vos outils de signature électronique
        </p>
      </div>

      {integTestMsg ? (
        <div style={{ marginBottom: 14, padding: "10px 14px", background: "rgba(26,122,68,0.1)", border: "1px solid rgba(26,122,68,0.35)", borderRadius: 8, fontSize: 13, color: GREEN }}>
          {integTestMsg}
        </div>
      ) : null}

      {/* Card Yousign */}
      <div style={cardStyle}>
        <div style={{ display: "flex", alignItems: "center", gap: 12, marginBottom: 14, flexWrap: "wrap" }}>
          <span style={{ fontSize: 13, fontWeight: 800, letterSpacing: "0.06em", color: INK, padding: "6px 14px", borderRadius: 8, border: `2px solid ${GOLD}`, background: SOFT_BG }}>
            Yousign
          </span>
        </div>
        <p style={{ margin: "0 0 16px", fontSize: 13, color: INK_SOFT, lineHeight: 1.55 }}>
          Signature électronique conforme RGPD · Valable en France et au Maroc
        </p>
        <a href="https://yousign.com" target="_blank" rel="noopener noreferrer" style={{ color: GOLD, fontWeight: 700, fontSize: 13 }}>
          Créer un compte Yousign →
        </a>
        <label style={{ ...labelStyle, marginTop: 18 }}>Clé API Yousign</label>
        <input
          type="password"
          style={inputStyle}
          value={yousignApi}
          onChange={(e) => setYousignApi(e.target.value)}
          placeholder="••••••••"
          autoComplete="off"
        />
        <label style={{ ...labelStyle, marginTop: 14 }}>Environnement</label>
        <select
          style={inputStyle}
          value={yousignEnv === "production" ? "production" : "test"}
          onChange={(e) => setYousignEnv(e.target.value)}
        >
          <option value="test">Test</option>
          <option value="production">Production</option>
        </select>
        <div style={{ display: "flex", gap: 10, marginTop: 18, flexWrap: "wrap" }}>
          <button
            type="button"
            onClick={() => {
              setIntegTestMsg("Yousign : test de connexion simulé (branchez l’API réelle pour valider la clé).");
              setTimeout(() => setIntegTestMsg(""), 4500);
            }}
            style={{
              padding: "10px 20px", background: GOLD, color: "#fff", border: "none", borderRadius: 8,
              fontSize: 13, fontWeight: 700, cursor: "pointer",
            }}
          >
            Tester la connexion
          </button>
          <button
            type="button"
            onClick={() => {
              writeLs("yoma_yousign_api_key", yousignApi);
              writeLs("yoma_yousign_env", yousignEnv);
              setIntegTestMsg("Paramètres Yousign enregistrés dans ce navigateur.");
              setTimeout(() => setIntegTestMsg(""), 3500);
            }}
            style={{
              padding: "10px 20px", background: GOLD, color: "#fff", border: "none", borderRadius: 8,
              fontSize: 13, fontWeight: 700, cursor: "pointer",
            }}
          >
            Enregistrer
          </button>
        </div>
      </div>

      {/* Card Docusign */}
      <div style={cardStyle}>
        <span style={{ fontSize: 13, fontWeight: 800, letterSpacing: "0.06em", color: INK, padding: "6px 14px", borderRadius: 8, border: `2px solid ${GOLD}`, background: SOFT_BG, display: "inline-block", marginBottom: 14 }}>
          Docusign
        </span>
        <p style={{ margin: "0 0 16px", fontSize: 13, color: INK_SOFT, lineHeight: 1.55 }}>
          Leader mondial de la signature électronique · Plan gratuit disponible
        </p>
        <a href="https://docusign.com" target="_blank" rel="noopener noreferrer" style={{ color: GOLD, fontWeight: 700, fontSize: 13 }}>
          Créer un compte Docusign →
        </a>
        <label style={{ ...labelStyle, marginTop: 18 }}>Clé d&apos;intégration Docusign</label>
        <input
          type="password"
          style={inputStyle}
          value={docusignKey}
          onChange={(e) => setDocusignKey(e.target.value)}
          placeholder="••••••••"
          autoComplete="off"
        />
        <label style={{ ...labelStyle, marginTop: 14 }}>Account ID Docusign</label>
        <input
          style={inputStyle}
          value={docusignAcct}
          onChange={(e) => setDocusignAcct(e.target.value)}
          placeholder="UUID du compte"
        />
        <div style={{ display: "flex", gap: 10, marginTop: 18, flexWrap: "wrap" }}>
          <button
            type="button"
            onClick={() => {
              setIntegTestMsg("Docusign : test de connexion simulé (branchez l’API réelle pour valider les identifiants).");
              setTimeout(() => setIntegTestMsg(""), 4500);
            }}
            style={{
              padding: "10px 20px", background: GOLD, color: "#fff", border: "none", borderRadius: 8,
              fontSize: 13, fontWeight: 700, cursor: "pointer",
            }}
          >
            Tester la connexion
          </button>
          <button
            type="button"
            onClick={() => {
              writeLs("yoma_docusign_key", docusignKey);
              writeLs("yoma_docusign_account_id", docusignAcct);
              setIntegTestMsg("Paramètres Docusign enregistrés dans ce navigateur.");
              setTimeout(() => setIntegTestMsg(""), 3500);
            }}
            style={{
              padding: "10px 20px", background: GOLD, color: "#fff", border: "none", borderRadius: 8,
              fontSize: 13, fontWeight: 700, cursor: "pointer",
            }}
          >
            Enregistrer
          </button>
        </div>
      </div>

      {/* Card Stripe */}
      <div style={cardStyle}>
        <div style={{ display: "flex", alignItems: "center", gap: 12, marginBottom: 14, flexWrap: "wrap" }}>
          <span style={{ fontSize: 13, fontWeight: 800, letterSpacing: "0.06em", color: INK, padding: "6px 14px", borderRadius: 8, border: `2px solid ${GOLD}`, background: SOFT_BG }}>
            Stripe
          </span>
          {stripePk.trim() ? (
            <span style={{ fontSize: 11, fontWeight: 700, letterSpacing: "0.08em", textTransform: "uppercase", color: "#fff", background: GREEN, padding: "5px 12px", borderRadius: 999 }}>
              Connecté
            </span>
          ) : null}
        </div>
        <p style={{ margin: "0 0 16px", fontSize: 13, color: INK_SOFT, lineHeight: 1.55 }}>
          Paiements en ligne sécurisés
        </p>
        <label style={labelStyle}>Clé publique Stripe</label>
        <input
          style={inputStyle}
          value={stripePk}
          onChange={(e) => setStripePk(e.target.value)}
          placeholder="pk_live_… ou pk_test_…"
        />
        <button
          type="button"
          onClick={() => {
            writeLs("yoma_stripe_pk", stripePk);
            setIntegTestMsg("Clé Stripe enregistrée dans ce navigateur.");
            setTimeout(() => setIntegTestMsg(""), 3500);
          }}
          style={{
            marginTop: 18, padding: "10px 24px", background: GOLD, color: "#fff", border: "none", borderRadius: 8,
            fontSize: 13, fontWeight: 700, cursor: "pointer",
          }}
        >
          Enregistrer
        </button>
      </div>

      {/* Bouton enregistrer */}
      <button
        onClick={handleSave}
        style={{
          width: "100%", padding: "14px 0",
          background: saved ? "#1A7A44" : GOLD,
          color: "#fff", border: "none", borderRadius: 9,
          fontSize: 15, fontWeight: 700, cursor: "pointer",
          letterSpacing: "0.04em", transition: "background 0.3s",
        }}
      >
        {saved ? "✓ Enregistré — persistera après actualisation" : "Enregistrer"}
      </button></div>
  );
}
